import React, { useEffect, useState } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import MyAccountContentHeader from '../MyAccountContentHeader/MyAccountContentHeader';
import MyAccountOrderPrescriptionQuestion from '../MyAccountOrderPrescriptionQuestion/MyAccountOrderPrescriptionQuestion';
import MyAccountOrderPrescriptionDetails from '../MyAccountOrderPrescriptionDetails/MyAccountOrderPrescriptionDetails';
import * as http from '../../../../utils/http';


type OrderData = {
  title: string;
  createdAt: string;
  status: string;
  prescription: {
    id: number;
    question: string;
    answer: string;
    question_type: string;
  }[];
}
const MyAccountOrderQuestionnaire = () => {
	const { setError, setLoading, country, refreshData } = useOutletContext<any>();
	const { order_hash_id: hashID } = useParams();
	const [orderData, setOrderData] = useState<OrderData | null>(null);
  	const [orderPrescriptionDetails, setOrderPrescriptionDetails] = useState<any>(null);

	useEffect(() => {
		window.scrollTo(0, 0);
		setLoading(true);

		http
			.getFromServer(`${country}/account/orders/${hashID}/questionnaire`, [http.MIDDLEWARES.CUSTOMER_ID])
			.then((response) => {
				setOrderData(response.data);
				setOrderPrescriptionDetails(response.data.orderPrescriptionDetails);
			})
			.catch((error) => {
				if (error.response.status === 404) {
					return setError(400);
				}

				window.clientLogger.error('Error in MyAccountOrderQuestionnaire: ', error);
				setError(500);
			})
			.finally(() => {
				setLoading(false);
			});
	}, [refreshData]);

	if (!hashID || !country) {
		return setError(400);
	}

  if (!orderData) {
    return <></>
  }

	return (
		<>
			<div className="account-content">
				<MyAccountContentHeader title={orderData['title']} description={''} />

				<MyAccountOrderPrescriptionDetails hashID={hashID} status={orderData.status} orderPrescriptionDetails={orderPrescriptionDetails} setOrderPrescriptionDetails={setOrderPrescriptionDetails} createdAt={orderData.createdAt} />

				{orderData.prescription.map((questionAnswer: any, index: number) => (
					<MyAccountOrderPrescriptionQuestion
						key={index}
						questionHtmlContent={questionAnswer.question}
						answerText={questionAnswer.answer}
						questionType={questionAnswer.question_type}
					/>
				))}
			</div>
		</>
	);
};

export default MyAccountOrderQuestionnaire;
